// help to easier the loading set up when use http client
// attach the params to url to make backend record in audit log correctly
export const showLoading = (loading: string | boolean, cacheable = false) => {
  return {
    "params": {
      loading: '' + loading
      // ,...(cacheable ? { '$cacheable$': 'true' } : {})
    }
  };
};

export const showProgressLoading = showLoading(true);
export const hideLoading = showLoading(false);
export const showSpinLoading = showLoading('spin');
export const cacheable = showLoading(false, true);
export const supressGlobalErrorHandler = {
  "params": {
    'supressGlobalErrorHandler': 'true',
  }
}
export const noSpinLoadingAndErrorHander = {
  "params": {
    loading: 'false',
    'supressGlobalErrorHandler': 'true',
  }
}
